import { call, put, takeLatest } from "redux-saga/effects";
import { 
    getUserCreditInfo, 
    getUserPctUnlockHistory
} from "../../helpers/backend_helper";
import { 
    getUserCreditInfoSuccess, 
    getUserPctUnlockHistorySuccess
} from "./actions";
import { GET_USER_CREDIT_INFO, GET_USER_PCT_UNLOCK_HISTORY } from "./actionTypes";

function* onGetUserCreditInfo ({payload:data}){
    try {
        const response = yield call(getUserCreditInfo);
        yield put(getUserCreditInfoSuccess(response));
        // console.log("User credit info fetched successfully:", response);
    } catch (error) {
        console.error("Error fetching user credit info:", error);
    }
}

function* onGetUserPctUnlockHistory({ payload: data }) {
    try {
        const response = yield call(getUserPctUnlockHistory, data);
        yield put(getUserPctUnlockHistorySuccess(response));
        // console.log("User PCT unlock history fetched successfully:", response);
    } catch (error) {
        console.error("Error fetching user PCT unlock history:", error);
    }
}

function* myCreditsSaga() {
    yield takeLatest(GET_USER_CREDIT_INFO, onGetUserCreditInfo);
    yield takeLatest(GET_USER_PCT_UNLOCK_HISTORY, onGetUserPctUnlockHistory);
}

export default myCreditsSaga;
